export default class ThemedicService {
  getAll() {
    return fetch("https://api.tradersr.com/api/themedic")
      .then(res => res.json());
  }  
}